import axios from 'axios'
import {ResponseObjectPaginated} from '../../../../../models'
import {BathRoomModel, GetPaginationBathRoomDto} from '../models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export function getBathRoomsService(dto: GetPaginationBathRoomDto) {
  return axios.post<ResponseObjectPaginated<BathRoomModel>>(`${BASEURL}/bathRoom/getList`, dto)
}
